module.exports = __webpack_public_path__ + "static/media/homepage_header_mobile_french.45eff9bd.jpg";